// extracted by mini-css-extract-plugin
export default {"main":"PetPlacement_main__nDn+l","buttonOutline":"PetPlacement_buttonOutline__Ysi3Q"};